import { render, staticRenderFns } from "./addNewddd.vue?vue&type=template&id=2fd72a63&"
import script from "./addNewddd.vue?vue&type=script&lang=js&"
export * from "./addNewddd.vue?vue&type=script&lang=js&"
import style0 from "./addNewddd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports